export const LANDING_HTML = `
  <!-- nav -->
  <header class="nav">
    <div class="wrap nav-in">
      <a href="/" class="brandmark">Artie<span class="dot">.</span></a>
      <nav class="nav-links">
        <a href="#how">How it works</a>
        <div class="nav-dd" id="indDd">
          <button class="nav-dd-btn" type="button">Industries <span data-icon="chevronD" data-size="13"></span></button>
          <div class="nav-dd-menu">
            <div class="nav-dd-mlabel">Explore the platform</div>
            <a class="nav-dd-opt" href="restaurants.html"><span class="ic" data-icon="utensils" data-size="16"></span><span><b>Restaurants</b><span class="s">Toast</span></span><span class="go" data-icon="arrowR" data-size="15"></span></a>
            <a class="nav-dd-opt" href="construction.html"><span class="ic" data-icon="hardhat" data-size="16"></span><span><b>Construction</b><span class="s">ELAS</span></span><span class="go" data-icon="arrowR" data-size="15"></span></a>
            <a class="nav-dd-opt" href="real-estate.html"><span class="ic" data-icon="building" data-size="16"></span><span><b>Real Estate</b><span class="s">Yardi</span></span><span class="go" data-icon="arrowR" data-size="15"></span></a>
          </div>
        </div>
        <a href="#try">Try it</a>
        <a href="#control">Security</a>
      </nav>
      <div class="right">
        <a href="#login" class="btn btn-ghost btn-sm login-btn">Login</a>
        <a href="#login" class="btn btn-brand btn-sm">Book a demo</a>
        <button class="theme-toggle" type="button" aria-label="Toggle light or dark mode" title="Toggle light / dark">
          <svg class="ic-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
          <svg class="ic-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>
        </button>
        <button class="nav-toggle" aria-label="Menu"><span data-icon="grid" data-size="22"></span></button>
      </div>
    </div>
  </header>

  <!-- hero -->
  <section class="hero dispatch">
    <svg class="hero-radar" viewBox="0 0 1200 780" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <defs>
        <radialGradient id="radarFade" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="rgba(52,211,153,0.16)"/>
          <stop offset="70%" stop-color="rgba(52,211,153,0.03)"/>
          <stop offset="100%" stop-color="transparent"/>
        </radialGradient>
      </defs>
      <g class="radar-g" transform="translate(880 360)">
        <circle r="360" fill="url(#radarFade)"/>
        <circle class="rr" r="110"/>
        <circle class="rr" r="200"/>
        <circle class="rr" r="300"/>
        <circle class="rr" r="400"/>
        <line class="rl" x1="0" y1="0" x2="-620" y2="120"/>
        <line class="rl" x1="0" y1="0" x2="-470" y2="-230"/>
        <line class="rl" x1="0" y1="0" x2="-360" y2="330"/>
        <line class="rl" x1="0" y1="0" x2="220" y2="-260"/>
        <line class="rl" x1="0" y1="0" x2="300" y2="180"/>
        <circle class="rn" cx="-620" cy="120" r="4"/>
        <circle class="rn" cx="-470" cy="-230" r="4"/>
        <circle class="rn" cx="-360" cy="330" r="4"/>
        <circle class="rn" cx="220" cy="-260" r="4"/>
        <circle class="rn" cx="300" cy="180" r="4"/>
        <circle class="rc" r="6"/>
      </g>
    </svg>
    <div class="wrap hero-in">
      <div class="hero-copy reveal">
        <div class="eyebrow pill"><i class="live-dot"></i> Artie is live — reading every system</div>
        <h1>Ask once<span class="g">.</span><br>Answered everywhere<span class="g">.</span></h1>
        <p class="lede">Artie reads across Toast, ELAS, Yardi, QuickBooks and the rest of your stack — then answers in plain language and does the work, live.</p>
        <div class="hero-cta">
          <a href="#login" class="btn btn-brand">Book a demo</a>
          <a href="#how" class="btn btn-ghost">See how it works <span data-icon="arrowR" data-size="15"></span></a>
        </div>
      </div>

      <div class="stat-card sc-1 reveal"><span class="sc-k">Systems wired in</span><span class="sc-v">11</span><span class="sc-s">live right now</span></div>
      <div class="stat-card sc-2 reveal"><span class="sc-k">Answers today</span><span class="sc-v">2,847</span><span class="sc-s">+18% vs last week</span></div>
      <div class="stat-card sc-3 reveal"><span class="sc-k">Avg response</span><span class="sc-v">1.2s</span><span class="sc-s">across every system</span></div>
      <div class="stat-card sc-4 reveal"><span class="sc-k">Actions automated</span><span class="sc-v">340</span><span class="sc-s">this week</span></div>
    </div>
  </section>

  <!-- logos -->
  <section class="section-pad hub-sec">
    <div class="wrap">
      <div class="shead center reveal">
        <div class="eyebrow">The intelligence layer</div>
        <h2>One agent, wired into everything you run.</h2>
      </div>
      <div class="hub" id="hub"></div>
    </div>
  </section>

  <!-- how it works -->
  <section class="section-pad" id="how">
    <div class="wrap">
      <div class="shead center reveal">
        <div class="eyebrow">Say what, not how</div>
        <h2>You name the outcome. Artie does the work — in three moves.</h2>
        <p>No data team, no migration. You ask — Artie handles the rest.</p>
      </div>
      <div class="pillars">
        <div class="pillar reveal">
          <div class="num">01</div>
          <div class="pico" data-icon="plug" data-size="20"></div>
          <h3>Connect</h3>
          <p>Link your POS, ERP, property, accounting, inbox — live in minutes.</p>
          <div class="conn" data-icon="arrowR" data-size="22"></div>
        </div>
        <div class="pillar reveal">
          <div class="num">02</div>
          <div class="pico" data-icon="sparkles" data-size="20"></div>
          <h3>Understand</h3>
          <p>Artie reads across all of it and joins it into one live model.</p>
          <div class="conn" data-icon="arrowR" data-size="22"></div>
        </div>
        <div class="pillar reveal">
          <div class="num">03</div>
          <div class="pico" data-icon="zap" data-size="20"></div>
          <h3>Act</h3>
          <p>Dashboards, forecasts, estimates, reminders — done, audited, reversible.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- see it / try it: one interactive demo across industries -->
  <section class="section-pad" id="try">
    <div class="wrap">
      <div class="shead center reveal">
        <div class="eyebrow">See it work</div>
        <h2>Pick a business. Ask Artie anything.</h2>
        <p>Three very different industries, one agent. Choose a world, tap a question — or type your own — and watch Artie answer live.</p>
      </div>

      <div class="idemo reveal">
        <div class="idemo-tabs" role="tablist" aria-label="Industries">
          <button class="idemo-tab is-active" type="button" data-v="0">Restaurants<span class="idemo-sub">Toast</span></button>
          <button class="idemo-tab" type="button" data-v="1">Construction<span class="idemo-sub">ELAS</span></button>
          <button class="idemo-tab" type="button" data-v="2">Real Estate<span class="idemo-sub">Yardi</span></button>
        </div>

        <div class="idemo-stage">
          <div class="idemo-info">
            <div class="idemo-panel is-active" data-v="0">
              <div class="iico" data-icon="utensils" data-size="22"></div>
              <h3>Restaurants</h3>
              <div class="conn-to"><span class="live-dot"></span>Connected to Toast</div>
              <div class="idemo-flag"><span class="ff" data-icon="sparkles" data-size="13"></span><span><b>Menu &amp; Margin Optimizer</b> — reprice, re-engineer, or cut every item.</span></div>
              <a href="restaurants.html" class="go">Explore the platform <span data-icon="arrowR" data-size="16"></span></a>
            </div>
            <div class="idemo-panel" data-v="1">
              <div class="iico" data-icon="hardhat" data-size="22"></div>
              <h3>Construction</h3>
              <div class="conn-to"><span class="live-dot"></span>Runs on the ELAS platform</div>
              <div class="idemo-flag"><span class="ff" data-icon="sparkles" data-size="13"></span><span><b>Inspection Report Analyzer</b> — a 1,000-page PDF, ranked and priced.</span></div>
              <a href="construction.html" class="go">Explore the platform <span data-icon="arrowR" data-size="16"></span></a>
            </div>
            <div class="idemo-panel" data-v="2">
              <div class="iico" data-icon="building" data-size="22"></div>
              <h3>Real Estate</h3>
              <div class="conn-to"><span class="live-dot"></span>Connected to Yardi</div>
              <div class="idemo-flag"><span class="ff" data-icon="sparkles" data-size="13"></span><span><b>Portfolio Forecasting</b> — model rent, renewals, and NOI live.</span></div>
              <a href="real-estate.html" class="go">Explore the platform <span data-icon="arrowR" data-size="16"></span></a>
            </div>
          </div>

          <div class="play">
            <div class="play-head">
              <span class="spk" aria-hidden="true"><svg viewBox="0 0 48 48" width="20" height="20"><g fill="currentColor"><path d="M24 25 C15.5 20 16 10 24 4 C32 10 32.5 20 24 25 Z"/><path d="M24 25 C15.5 20 16 10 24 4 C32 10 32.5 20 24 25 Z" transform="rotate(120 24 24)"/><path d="M24 25 C15.5 20 16 10 24 4 C32 10 32.5 20 24 25 Z" transform="rotate(240 24 24)"/></g><circle cx="24" cy="24" r="4.5" fill="currentColor"/></svg></span>
              <b>Artie</b>
              <span class="play-sys" id="play-sys">~ toast</span>
              <span class="play-live"><span class="live-dot"></span>live</span>
            </div>
            <div class="play-body" id="play-body"></div>
            <form class="play-bar" id="play-form" autocomplete="off">
              <span class="play-caret">›</span>
              <input class="play-input" id="play-input" type="text" placeholder="Ask Artie something…" aria-label="Ask Artie a question" />
              <button class="play-send" type="submit" aria-label="Send" data-icon="send" data-size="18"></button>
            </form>
            <div class="play-chips" id="play-chips"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- stay in control -->
  <section class="section-pad section-dark" id="control">
    <div class="wrap ctrl-grid">
      <div class="reveal">
        <div class="eyebrow">Stay in control</div>
        <h2>An agent that acts — only where you let it.</h2>
        <p>Every action is permissioned, logged, and reversible — the leverage of an autonomous agent without handing over the keys.</p>
      </div>
      <div class="ctrl-cards reveal">
        <div class="ctrl-card">
          <div class="ci" data-icon="shield" data-size="20"></div>
          <b>Permissioned</b>
          <p>Acts only within the roles you grant — enforced server-side, not just hidden in the UI.</p>
        </div>
        <div class="ctrl-card">
          <div class="ci" data-icon="eye" data-size="20"></div>
          <b>Fully audited</b>
          <p>Every read and action logged — who, what, when — inspect the trail any time.</p>
        </div>
        <div class="ctrl-card">
          <div class="ci" data-icon="refresh" data-size="20"></div>
          <b>Reversible</b>
          <p>Artie proposes; you approve before it commits — and anything can be undone.</p>
        </div>
        <div class="ctrl-card">
          <div class="ci" data-icon="layers" data-size="20"></div>
          <b>Tenant-isolated</b>
          <p>Your data stays yours — every company isolated, nothing crosses the boundary.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- cta -->
  <section class="cta-band section-dark" id="cta">
    <div class="wrap">
      <div class="reveal">
        <div class="eyebrow" style="justify-content:center;display:flex">Get started</div>
        <h2 style="margin-top:14px">See Artie on your data.</h2>
        <p>Bring one system — your POS, ERP, or property platform — and we'll stand up the intelligence layer live on your numbers in 30 minutes.</p>
        <div style="display:flex;gap:12px;justify-content:center;flex-wrap:wrap">
          <a href="#login" class="btn btn-brand">Book a 30-minute demo →</a>
          <a href="#try" class="btn btn-ghost">See it in action</a>
        </div>
      </div>
    </div>
  </section>

  <!-- footer -->
  <footer class="foot section-dark">
    <div class="wrap foot-in">
      <a href="/" class="brandmark">Artie<span class="dot">.</span></a>
      <nav class="fl">
        <a href="#how">How it works</a>
        <a href="#try">See it work</a>
        <a href="#control">Security</a>
        <a href="#login">Book a demo</a>
      </nav>
      <div class="cp">© ${new Date().getFullYear()} Artie — the intelligence layer · Demo</div>
    </div>
  </footer>

  <script src="assets/icons.js"></script>
  <script src="assets/charts.js"></script>
  <script src="assets/landing.js"></script>
`;
